import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Button, Input } from "reactstrap";
import { toast } from "react-toastify";
import { createAmenityApi, updateAmenityApi, } from "../../apiServices/projectServices";

const AmenityModal = ({ isOpen, toggle, mode, selected, onSuccess }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  console.log({ mode, selected });
  useEffect(() => {
    if (mode === "edit" && selected) {
      setName(selected.name);
    } else {
      setName("");
    }
  }, [mode, selected]);

  const handleSubmit = async () => {
    if (!name) return toast.error("Name required");

    try {
      setLoading(true);

      let res;
      if (mode === "edit") {
        res = await updateAmenityApi(selected._id, { name });
      } else {
        res = await createAmenityApi({ name });
      }

      if (!res.success) return toast.error(res.message);

      toast.success("Saved");
      onSuccess();
      // toggle();
    } catch (err) {
      toast.error("Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
        <Input
          placeholder="Amenity Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <div className="text-end mt-3">
          <Button
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </Button>
        </div>
      </>
  );
};

export default AmenityModal;